import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import StyledPageMenuIcon from "../../Layout/PageMenu/PageMenuIcon";

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const CommandDeleteRowButton = ({ onClick, disabled = false }: Props) => {
  return (
    <Button disabled={disabled} onClick={() => onClick()}>
      <StyledPageMenuIcon icon={faTrashCan} style={{ marginRight: 0 }} />
    </Button>
  );
};
